import { apiClient } from "../../base/ApiClient";

export const createReviewNotes = async (formData) => {
  const response = await apiClient.post(
    `/communications/review-notes/`,
    formData
  );
  return response;
};

export const getReviewNotes = async (job_id) => {
  const response = await apiClient.get(
    `/communications/review-notes/?job_id=${job_id}`
  );
  return response.data;
};
